declare global {
  interface Window {
    Calendly: any
  }
}

export default window.Calendly